import {
  DocumentTableDocument,
  DocumentTableQuery,
  FileDetailSectionDocument,
  FileDetailSectionQuery,
  RemoveDocumentMutation,
  SaveDocumentFormDocument,
  SaveDocumentFormQuery,
  useRemoveDocumentMutation
} from 'generated/graphql';
import { gqlCacheUtil } from 'modules/common';
import React from 'react';


export function useRemoveDocument() {
  const [
    fnMutate,
    tuple
  ] = useRemoveDocumentMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (id: string) => {
      await fnMutate({
        variables: {
          id
        },
        updateQueries: {
          ...gqlCacheUtil.genUpdateQueryMap<DocumentTableQuery, RemoveDocumentMutation>(
            /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
            DocumentTableDocument, (prevState, { mutationResult, queryVariables }) => {
              if (!mutationResult || !prevState.project?.documents) {
                return prevState;
              }

              const documents = prevState.project?.documents.filter((node) => node.id !== mutationResult.data?.deleteDocument);


              return {
                ...prevState,
                project: {
                  ...prevState.project,
                  documents: documents
                }
              };
            }
          ),
          ...gqlCacheUtil.genUpdateQueryMap<SaveDocumentFormQuery, RemoveDocumentMutation>(
            SaveDocumentFormDocument, (prevState, { mutationResult }) => {
              if (!prevState && !mutationResult) {
                return prevState;
              }
              return {
                ...prevState,
                document: null
              };
            }
          ),
          ...gqlCacheUtil.genUpdateQueryMap<FileDetailSectionQuery, RemoveDocumentMutation>(
            FileDetailSectionDocument, (prevState, { mutationResult }) => {
              if (!prevState.document || !mutationResult.data?.deleteDocument) {
                return prevState;
              }


              return {
                ...prevState,
                document: null
              };
            }
          )
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
